export default __webpack_public_path__ + "static/media/btn-quick-start.75697d57.svg";